import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { ImageFit } from '../../themes/theme';
import { WidgetType } from '../../utils/widgetsUtils';

const InfoHotspotContentSchema = z.object({
  title: z.string(),
  content: z.string().optional(),
  src: z.string().optional(),
  alt: z.string().optional(),
  infoDescription: z.string()
});

const InfoHotspotSchema = z.object({
  id: z.string(),
  isNew: z.boolean(),
  type: z.string(),
  position: z.object({
    top: z.string(),
    left: z.string()
  }),
  text: InfoHotspotContentSchema,
  image: InfoHotspotContentSchema,
  audio: InfoHotspotContentSchema,
  link: InfoHotspotContentSchema,
  embed: InfoHotspotContentSchema
});

export const FocusAreaSchema = z.object({
  enabled: z.boolean(),
  x: z.number().min(0).max(100),
  y: z.number().min(0).max(100),
  width: z.number().positive().max(100),
  height: z.number().positive().max(100)
});

export const HotspotWidgetStaticSchema = BaseWidgetSchema(WidgetType.Hotspot).extend({
  children: z.array(z.string()).optional(), // `children` is optional because it is not used in the Hotspot's `create` function
  imageSrc: z.string(),
  imageFit: z.nativeEnum(ImageFit),
  imageDescription: z.string(),
  focusArea: FocusAreaSchema.optional(),
  iconStyle: z.string(),
  withNumbering: z.boolean(),
  withZoom: z.boolean(),
  infoHotspots: z.record(z.string(), InfoHotspotSchema),
  infoHotspotsOrder: z.array(z.string()),
  style: z
    .object({
      infoColor: z.string().nullable().optional()
    })
    .optional()
});

export type HotspotWidgetStaticSchemaType = z.infer<typeof HotspotWidgetStaticSchema>;
export type InfoHotspotStaticType = z.infer<typeof InfoHotspotSchema>;
